import { ICaseStatusModel } from "../../../models/Cases/CaseDetailsModel";

interface ICaseDetailsStatusProps {
  status: ICaseStatusModel | null;
  className?: string
}

const CaseDetailsStatus = (props: ICaseDetailsStatusProps) => {

  return (
    <div className={`statusCardContainer ${props?.className ?? ''}`}>
      <div className={`line outer ${props?.className ?? ''}`}>
        <div className="statusHeadingcontainer">
          <p className="statusheading">{props?.status?.heading || '--'}</p>
        </div>
      </div> 
      { props?.status?.value?.map((each, key) => (
        <div className={`line inner ${props?.className ?? ''}`} key={key}>
          <div className="statusDataFC">
            <p className="stausDatatext">
              {each}
            </p>
          </div>
        </div>
      )) }
    </div>
  )
}

export default CaseDetailsStatus